import { DotProps } from 'recharts';
import { TARGET_THRESHOLD_COLORS } from '../../adherence/targets/targets.type';

import { TargetThreshold } from '../../adherence/targets/targets.type';

export const ThresholdAwareLineDot = ({
  color,
  targetThresholds,
  ...props
}: Omit<DotProps, 'payload'> & {
  color: string;
  targetThresholds: Record<string, TargetThreshold | null>;
  payload?: { date: string; [key: string]: any };
}) => {
  const { cx, cy, onClick, payload } = props;

  if (cx === undefined || cy === undefined || !payload?.date) {
    return null;
  }

  const threshold = targetThresholds[payload.date];
  const dotColor = threshold ? TARGET_THRESHOLD_COLORS[threshold] : color;

  const handleClick = (event: React.MouseEvent<SVGCircleElement>) => {
    if (onClick) {
      onClick(props, event);
    }
  };

  if (cx === null || cy === null) {
    return null;
  }

  return (
    <g>
      {/* Invisible larger circle for better click detection */}
      <circle
        cx={cx}
        cy={cy}
        r={15}
        fill="transparent"
        stroke="transparent"
        strokeWidth={0}
        onClick={handleClick}
        style={{ cursor: onClick ? 'pointer' : 'default' }}
        pointerEvents="all"
        role={onClick ? 'button' : undefined}
        tabIndex={onClick ? 0 : undefined}
        aria-label={threshold ? `Data point with ${threshold.toLowerCase()} threshold` : 'Data point'}
      />
      {/* Large semi-transparent circle */}
      <circle cx={cx} cy={cy} r={8} fill={dotColor} fillOpacity={0.2} pointerEvents="none" />
      {/* Inner colored circle */}
      <circle cx={cx} cy={cy} r={3.5} stroke="none" fill={dotColor} pointerEvents="none" />
    </g>
  );
};
